import { useCallback } from 'react'
import ButtonModalSortList, { ItemSortFunction } from '../../../../../../../../../../baseComponents/Sorts/ButtonModalSortList'
import { BaseButtonModalSortListProps } from '../../../../../../../../../../baseComponents/Sorts/ButtonModalSortList/types'
import { twinFetchPostText } from '../../../../../../../../../../utils/globals/data'
import { TwinDictionary } from '../../../../../../../../../../utils/globals/dictionary'
import { parseShippingServiceWorkingCenter } from './function'


interface ShippingServiceWorkingCenterSortButtonProps extends BaseButtonModalSortListProps {
    extraWhereParams: TwinDictionary
}

const ShippingServiceWorkingCenterSortButton: React.FC<ShippingServiceWorkingCenterSortButtonProps> = ({ userPermissions, ...rest }) => {
    const { updateOrder } = useShippingServiceWorkingCenterSortButtonLogic()
    return (
        <ButtonModalSortList updateData={updateOrder} userPermissions={userPermissions} getDataFrom='/api/app/workingCenter/workingCenterShippingService/getAllWorkingCenterShippingServices' {...rest} parseDataFnc={parseShippingServiceWorkingCenter as any} />
    )
}


const useShippingServiceWorkingCenterSortButtonLogic = () => {
    const updateOrder: ItemSortFunction = useCallback(async (data) => {
        const res = await twinFetchPostText('/api/app/workingCenter/workingCenterShippingService/updateWorkingCenterShippingServiceOrder', { workingCenterShippingServices: data })
        if (res) {
            return true
        }
        return false
    }, [])

    return { updateOrder }
}

export default ShippingServiceWorkingCenterSortButton